/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkRunItemUpdatedMessage } from '../../models/benchmark-run-item-updated-message';

export interface GetnotificationsBenchmarkRunItemUpdatedSchema$Params {
}

export function getnotificationsBenchmarkRunItemUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsBenchmarkRunItemUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunItemUpdatedMessage>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsBenchmarkRunItemUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BenchmarkRunItemUpdatedMessage>;
    })
  );
}

getnotificationsBenchmarkRunItemUpdatedSchema.PATH = '/api/hubs/notifications/BenchmarkRunItemUpdated';
